/**
 * This file automatically registers this package with webpack and creates a bundle named `lazy-required-loader`.
 * It starts deferred bundle loading when the bundle is loaded.
 */
import '@github-ui/turbo'
import '@primer/view-components'

import {startLazyRequiredLoader} from './lazy-required-loader'

startLazyRequiredLoader()
